import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { colors } from './colors';
import { fonts } from './typography';

const customConfig = defineConfig({
  globalCss: {
    body: { bg: 'paper', color: 'ink', fontFamily: 'body' }
  },
  theme: {
    tokens: {
      colors,
      fonts
    }
  }
});

export const system = createSystem(defaultConfig, customConfig);
